import { useTranslation } from "react-i18next"
import { AppHeader } from "../components/AppHeader";
import Cookie from "../svg/cookie";
import botconfig from "../botconfig";
export function Page403() {
    const { t } = useTranslation()
    return (
        <div>
            <AppHeader/>
            <div style={{ marginInline: "auto", flex: 1, maxWidth: 1400, display: "flex", flexDirection: "column", alignItems: "center", height: "calc(100vh - 6rem)", justifyContent: "center" }}>
                <Cookie/>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", fontSize: 50, textAlign: "center" }}>
                    <svg fill="var(--color)" height="200px" width="200px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xmlSpace="preserve"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <path d="M256,0C114.615,0,0,114.615,0,256s114.615,256,256,256s256-114.615,256-256S397.385,0,256,0z M384,283.429H128v-54.857 h256V283.429z"></path> </g> </g> </g></svg>
                    <span style={{ color: "var(--color)" }}>{t("Доступ запрещён")}</span>    
                </div>
                <div style={{ paddingTop: 30 }}>
                    <button className="button primary" style={{ padding: "0 3rem" }} onClick={() => window.location.replace(botconfig.root_path+botconfig.website_port)}>{t("Вернуться на главную")}</button>
                </div>
            </div>
        </div>  
    )
}